module.exports = __webpack_public_path__ + "img/ic_twitter_select@2x.3c61935.png";